import { featureFlagStore as e } from "./lib/store/featureFlagsStore.js";
import { del as t } from "/home/runner/work/oko-web/oko-web/node_modules/idb-keyval/dist/index.js";
import { setContext as n } from "/home/runner/work/oko-web/oko-web/node_modules/@sentry/react/build/esm/index.js";
var r = { sentry: {
	enabled: !0,
	dsn: "https://2f880989a4944173a854f56a82f320b5@o4504084613300224.ingest.us.sentry.io/4504084711211008",
	tracesSampleRate: 1
} }, i = /* @__PURE__ */ function(e) {
	return e.OLY_AUTH = "__oly_web_auth__", e.OLY_NEWSLETTER = "__oly_signup_newsletter__", e.SKETCHFAB_AUTH = "__oly_sketchfab_auth_v1__", e;
}({}), a = "__oly_env_preference__", o = "__oly_tenant_preference__", s, c = (e) => {
	e && t(e), localStorage.removeItem("__oly_web_auth__");
}, l = r, u = {}, d = (e) => new Promise((t) => {
	fetch(`/environment.json?t=${Date.now()}`).then((e) => e.json()).then((r) => {
		let i = localStorage.getItem(a), o = new URLSearchParams(window.location.search), s = !1;
		if (o.has("environment")) {
			let t = o.get("environment"), n = r.endpoints.CHSEnvironmentOptions.find((e) => e.name === t);
			n && (i || r.endpoints.CHS_BASE) !== n.value && (c(e), localStorage.setItem(a, n.value)), o.delete("environment"), s = !0;
		}
		if (o.has("tenant") && r.tenantSwitching && (m(o.get("tenant")), o.delete("tenant"), s = !0), s) {
			let e = new URLSearchParams(o);
			Array.from(e).length > 0 ? window.location.assign(`${window.location.origin}${window.location.pathname}?${e}`) : window.location.assign(`${window.location.origin}${window.location.pathname}`);
		}
		let l = r.endpoints.CHSEnvironmentOptions.findIndex((e) => e.value === i);
		i && l > -1 && (r.endpoints.CHS_BASE = i), r.type = r.endpoints.CHS_BASE.replace(/https:\/\/ogs\.magnopus-([a-z]+)\.cloud/gm, "$1"), r.type === r.endpoints.CHS_BASE && window.location.hostname !== "localhost" && (r.type = "prod"), u = r, n("CHSEnvironment", { env: r.endpoints.CHS_BASE }), t(r);
	});
}), f = (e) => {
	u.endpoints.CHSEnvironmentOptions.findIndex((t) => t.value === e) > -1 && localStorage.getItem(a) !== e && (localStorage.setItem(a, e), c(), window.location.reload());
}, p = (e) => {
	let t = u.endpoints.CHSEnvironmentOptions.find((e) => e.value === u.endpoints.CHS_BASE)?.name;
	return t && e ? e + t : t || "";
}, m = (e) => {
	(localStorage.getItem(o) || e !== "") && (e !== null && e.length > 0 ? localStorage.setItem(o, e) : localStorage.removeItem(o), window.location.reload());
}, h = () => localStorage.getItem(o), g = () => h() || s || u.tenant, _ = (e) => {
	s = e;
}, v = () => {
	localStorage.getItem(o) !== null && (localStorage.removeItem(o), window.location.reload());
};
window.selectEndpoint = f;
var y = () => u.endpoints?.CHSEnvironmentOptions.find((e) => e.value === u.endpoints.CHS_BASE)?.name, b = () => {
	let e = y();
	return `https://${u.endpoints?.StreamingBaseUrls.find((t) => t.name === e)?.value}`;
}, x = () => {
	let e = y(), t = u.endpoints?.StreamingBaseUrls?.find((t) => t.name === e)?.value;
	return t ? `https://${t}` : void 0;
}, S = () => {
	let e = y();
	return u.endpoints?.CHSEnvironmentOptions.find((t) => t.name === e)?.value;
}, C = () => u.nodey?.serverUrl, w = (e) => {
	if (!e) return !1;
	try {
		let { hostname: t } = new URL(e);
		return u.endpoints?.StreamingBaseUrls.some(({ value: e }) => t.includes(e)) ?? !1;
	} catch {
		return !1;
	}
}, T = (e, t) => t === !0 && w(e) ? "use-credentials" : "anonymous", E = (t) => T(t, e((e) => e.anonFeatureFlags.get("asset_security"))), D = (t) => T(t, e.getState().anonFeatureFlags.get("asset_security")), O = async (e, t, n) => {
	let r = (await e("oko", t, n)).settings, i = /* @__PURE__ */ new Map();
	return r.forEach((e, t) => {
		i.set(t, e === "true");
	}), i;
}, k = async (e, t, n, r) => {
	let i = (await e(t, "oko", n, r)).settings, a = /* @__PURE__ */ new Map();
	return i.forEach((e, t) => {
		a.set(t, e === "true");
	}), a;
};
//#endregion
export { f as _, u as a, E as b, D as c, y as d, C as f, v as g, d as h, g as i, O as l, w as m, p as n, S as o, x as p, h as r, k as s, i as t, b as u, m as v, l as x, _ as y };
